
import './MyCertificate.module.scss';

function MyCertificate() {
    return (
        <>
            <div className="components_wrap">
                <span>회원확인증</span>
            </div>
        </>
    );
}

export default MyCertificate;